import 'chartjs-adapter-moment'

import { DatePipe } from '@angular/common'
import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core'
import { ChartDataset } from 'chart.js/auto'
import { ESTPipe } from 'src/app/features/shared/pipes/est.pipe'
import { HistoricalPrice } from 'src/app/models/price-response.model'
import { ProfileBody } from 'src/app/models/profile-response.model'
import { PriceHistoryService } from 'src/app/services/Price-History/price-history.service'
@Component({
  selector: 'app-one-month',
  templateUrl: './one-month.component.html',
  styleUrls: ['./one-month.component.scss'],
})
export class OneMonthComponent implements OnChanges {
  @Input() data: any
  @Input() profileData: ProfileBody
  @Input() priceHistorySearchUrl: any
  @Input() modelLabel: string
  @Input() shareSplitDate: string | null = null
  @Input() shareSplitPrice: number | null = null

  datasets: ChartDataset[] = [{ data: [], label: '' }]
  barDatasets: ChartDataset[] = [{ data: [], label: '' }]
  labels: any
  labelText = ''
  currentTabData: any
  chatLabels: string[] = []
  barChatLabels: string[] = []
  chartIndex: number
  currentHistoricalPrice: any
  currentDate: any
  public datePipe: DatePipe
  noShowLoader = false
  infoNotAvailable = false
  @Input() historicalPrice: HistoricalPrice
  tableData = []
  historicalTableData = []
  displayToggle = 'chart'
  public pageNumber = 1
  estPipe: ESTPipe

  constructor(
    public readonly priceHistoryService: PriceHistoryService,
    private readonly cdRef: ChangeDetectorRef,
  ) {
    this.estPipe = new ESTPipe()
  }

  ngOnChanges(): void {
    this.inItOneMonthChanges()
  }

  onChange(event) {
    this.displayToggle = event
  }

  inItOneMonthChanges() {
    if (this.data && this.profileData) {
      const ProfileIdentifier =
        this.profileData.ticker ?? this.profileData.fundId
      const historyFromCache = this.priceHistoryService.responseCache.get(
        `vmf/api/${ProfileIdentifier}/${this.data}`,
      )

      if (historyFromCache) {
        this.oneMonthChange(historyFromCache)
      } else {
        this.priceHistoryService
          .getPriceHistory(ProfileIdentifier, this.data)
          .subscribe((params) => {
            this.priceHistoryService.responseCache.set(
              `vmf/api/${ProfileIdentifier}/${this.data}`,
              params,
            )
            this.oneMonthChange(params)
          })
      }
    }
  }
  oneMonthChange(params) {
    let i = 0
    if (params.nav === undefined) {
      this.infoNotAvailable = true
      this.noShowLoader = true
    } else {
      params.nav[0].item.forEach((it) => {
        let formatDate = ''
        if (it.asOfDate !== this.chatLabels[i - 1]) {
          this.datasets[0].data.push(Number(it.price))
          formatDate = this.estPipe.transform(it.asOfDate)
          if (this.chatLabels.indexOf(formatDate) < 0) {
            this.tableData.push(it)
          }
          this.chatLabels.push(formatDate)
          i++
        }
      })
    }

    this.currentDate = this.chatLabels[this.chatLabels.length - 1]
    this.currentHistoricalPrice =
      this.datasets[0].data[this.datasets[0].data.length - 1]
    this.noShowLoader = true
  }

  public greaterThan(index: number) {
    return index > 0 || index === 0
  }

  onDataUpdated($event: {
    labels: string[]
    datasets: any[]
    splitIndex: number
  }) {
    this.chatLabels = $event.labels
    this.datasets = $event.datasets
  }

  chartMouseOut() {
    this.chartIndex = this.datasets[0].data.length - 1
  }

  activeItemChanged($event) {
    this.chartIndex = $event.index
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges()
  }
  setPageNumber(changedNumber: number) {
    this.pageNumber = changedNumber
    const max = 10
    this.historicalTableData = this.tableData.slice(
      (this.pageNumber - 1) * max,
      this.pageNumber * max,
    )
  }
}
